
import { defineComponent, reactive, toRefs } from "vue";

export default defineComponent({
  name: "TabBar",
  props: {
    active: {
      type: String,
      default: "chat",
    },
  },
  setup() {
    const data = reactive({
      tabBarList: [
        {
          key: "home",
          icon: "icon-home",
          href: process.env.VUE_APP_HOST,
          title: "首页",
        },
        {
          key: "job",
          icon: "icon-job",
          href: `${process.env.VUE_APP_HOST}/job`,
          title: "职位",
        },
        {
          key: "chat",
          icon: "icon-chat",
          href: `${process.env.VUE_APP_PUBLIC_PATH}`,
          title: "消息",
        },
        {
          key: "user",
          icon: "icon-user",
          href: process.env.VUE_APP_C_HOST,
          title: "我的",
        },
      ],
    });
    return {
      ...toRefs(data),
    };
  },
});
